module.exports = __webpack_public_path__ + "static/media/14-log-screen.e4f688f6.svg";